import { func } from 'prop-types';
import { useIntl } from 'react-intl';

import QuickDateSelector from 'components/common/TimeNavigation/QuickDateSelector';
import { DISPLAY_YEAR } from 'constants/dateFormats';
import { financialInsightsFiltersShape } from 'constants/shapes';
import { useTeams } from 'hooks';
import { addYears, dateToString } from 'utils/date';

import { Container, StyledSelect } from './styles';

const Filters = ({ filters, setFilters, getFinancialOverviewRequest }) => {
  const intl = useIntl();
  const { formattedTeams } = useTeams(true);
  const { year, departmentId } = filters;

  const handleOptions = (key, value) => {
    const params = { ...filters, [key]: value };
    setFilters(params);
    getFinancialOverviewRequest(params);
  };

  const handleQuickSelectorChange = (value, forward = true) => {
    const newDate = value || addYears(forward ? 1 : -1, year);
    handleOptions('year', dateToString(newDate, DISPLAY_YEAR));
  };

  return (
    <Container>
      <StyledSelect
        id="departmentIdTxt"
        name="departmentId"
        options={formattedTeams}
        isSearchable
        isClearable
        variant="new"
        withoutHighlight
        placeholder={intl.formatMessage({ id: 'common.cap.allDepartments' })}
        onChange={data => {
          handleOptions('departmentId', data?.id);
        }}
        value={formattedTeams.find(({ id }) => id === departmentId)}
      />
      <QuickDateSelector onChange={handleQuickSelectorChange}>
        <span>{year}</span>
      </QuickDateSelector>
    </Container>
  );
};

Filters.propTypes = {
  filters: financialInsightsFiltersShape,
  getFinancialOverviewRequest: func,
  setFilters: func
};

export default Filters;
